import {
  FilterMinimalStyleCircle,
  Project,
  Repeat,
  Timeline,
} from '@griply/assets';
import { Calendar, GoalPlans, Heart, Image, Target } from 'shared/assets/icons';
import { IconProps } from 'shared/components/ui/icon';

export type PremiumUsp = {
  label: string;
  icon: IconProps['icon'];
  tooltip?: string;
};

export const premiumUsps: PremiumUsp[] = [
  { label: 'dialogs.premium.usp.1', icon: Target },
  { label: 'dialogs.premium.usp.2', icon: Repeat },
  { label: 'dialogs.premium.usp.11', icon: Project },
  {
    label: 'dialogs.premium.usp.3',
    icon: Calendar,
    tooltip: 'dialogs.premium.usp.3.tooltip',
  },
  {
    label: 'dialogs.premium.usp.4',
    icon: Timeline,
    tooltip: 'dialogs.premium.usp.4.tooltip',
  },
  { label: 'dialogs.premium.usp.5', icon: GoalPlans },
  {
    label: 'dialogs.premium.usp.6',
    icon: Repeat,
    tooltip: 'dialogs.premium.usp.6.tooltip',
  },
  { label: 'dialogs.premium.usp.7', icon: FilterMinimalStyleCircle },
  { label: 'dialogs.premium.usp.9', icon: Heart },
  { label: 'dialogs.premium.usp.10', icon: Image },
];
